import { CollapseProps } from "antd";
import { FC } from "react";

import { StyledNestedAccordion } from "./Styled";

interface NestedAccordionProps extends CollapseProps {
    level: number;
    isLast?: boolean;
}

export const NestedAccordion: FC<NestedAccordionProps> = ({
    level,
    isLast = false,
    ...rest
}) => {
    return <StyledNestedAccordion $level={level} $isLast={isLast} {...rest} />;
};
